import React, {Component} from 'react';
import {RadioButtonOption} from "../../elements/RadioButtonOption";
import {
    DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET, DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_ONLY_COST,
    DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET
} from "../../../daily_limits";
import BudgetValueInput from "../../elements/BudgetValueInput";
import { withTranslation } from 'react-i18next';


class ClientAdAccountFormBaseClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dailyLimitEnabled: true,
            daily_limit_type: DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET,
            daily_limit_value: null,
            daily_limit_currency: "ARS"
        }

        this.handleDailyLimitChange = this.handleDailyLimitChange.bind(this);
        this.handleDailyLimitDeactivate = this.handleDailyLimitDeactivate.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
    }

    _getDataToPost() {
        const daily_limit_currency = this.state.dailyLimitEnabled ? this.state.daily_limit_currency : null;
        const daily_limit_value = this.state.dailyLimitEnabled ? this.state.daily_limit_value : null;

        return {
            'daily_limit_type': this.state.daily_limit_type,
            'daily_limit_currency': daily_limit_currency,
            'daily_limit_value': daily_limit_value,
        };
    }

    handleDailyLimitChange(newType) {
        this.setState({
            daily_limit_type: newType,
            dailyLimitEnabled: true
        });
    }

    handleCurrencyChange(newCurrency) {
        this.setState({
            daily_limit_currency: newCurrency
        });
    }

    handleAmountChange(newAmount) {
        this.setState({
            daily_limit_value: newAmount
        });
    }

    handleDailyLimitDeactivate() {
        this.setState({
            dailyLimitEnabled: false,
        });
    }

    isAdAccountTypeSelected() {
        return this.state.dailyLimitEnabled && this.getDailyLimitType() === DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET
    }

    isCampaignTypeSelected() {
        return this.state.dailyLimitEnabled && this.getDailyLimitType() === DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET
    }

    getDailyLimitType() {
        return this.state.daily_limit_type ? this.state.daily_limit_type : DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_ONLY_COST
    }

    getDailyLimitCurrency() {
        // Sino tiene ningún valor, poner ARS como default
        return this.state.daily_limit_currency ? this.state.daily_limit_currency : "ARS"
    }

    renderRadioButtonOptions() {
        const { t } = this.props;
        return [
            <RadioButtonOption
                key="adAccount"
                isSelected={this.isAdAccountTypeSelected()}
                onClick={() => this.handleDailyLimitChange(DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET)}
                label={<span>{t('client_ad_account_form_base.daily_limit_ad_account')}</span>}
                note={t('client_ad_account_form_base.daily_limit_ad_account_note')}>
                {this.renderDailyLimitInputs()}
            </RadioButtonOption>,
            <RadioButtonOption
                key="campaign"
                isSelected={this.isCampaignTypeSelected()}
                onClick={() => this.handleDailyLimitChange(DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET)}
                label={<span>{t('client_ad_account_form_base.daily_limit_campaign')}</span>}
                note={t('client_ad_account_form_base.daily_limit_campaign_note')}>
                {this.renderDailyLimitInputs()}
            </RadioButtonOption>,
            <RadioButtonOption
                key="deactivate"
                isSelected={!this.state.dailyLimitEnabled}
                onClick={this.handleDailyLimitDeactivate}
                label={t('client_ad_account_form_base.no_daily_limit')}
            />
        ];
    }

    renderDailyLimitInputs() {
        if (!this.state.dailyLimitEnabled)
            return;

        return <div style={{maxWidth: "250px"}}><BudgetValueInput canEditCurrency={true}
                                                                  hideCurrency={false}
                                                                  budgetCurrency={this.getDailyLimitCurrency()}
                                                                  currencyReadOnly={false}
                                                                  onCurrencyChange={this.handleCurrencyChange}
                                                                  onAmountChange={this.handleAmountChange}
                                                                  budgetAmount={this.state.daily_limit_value}/></div>
    }
}

export { ClientAdAccountFormBaseClass };
export const ClientAdAccountFormBase = withTranslation()(ClientAdAccountFormBaseClass);
export default ClientAdAccountFormBase;